import {
  TENANT_AT,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
  TENANT_TEST,
} from 'shared/consts/tenants'
import logoAtDesktop from 'views/assets/images/logos/logo-AT-desktop.svg'
import logoAtMobile from 'views/assets/images/logos/logo-AT-mobile.svg'
import logoComDesktop from 'views/assets/images/logos/logo-COM-desktop.svg'
import logoComMobile from 'views/assets/images/logos/logo-COM-mobile.svg'
import logoFrDesktop from 'views/assets/images/logos/logo-FR-desktop.svg'
import logoFrMobile from 'views/assets/images/logos/logo-FR-mobile.svg'
import logoItDesktop from 'views/assets/images/logos/logo-IT-desktop.svg'
import logoItMobile from 'views/assets/images/logos/logo-IT-mobile.svg'
import logoTestDesktop from 'views/assets/images/logos/logo-TEST-desktop.svg'
import logoTestMobile from 'views/assets/images/logos/logo-TEST-mobile.svg'

export const MOBILE = 'mobile'
export const DESKTOP = 'desktop'
export const MOBILE_REBRANDING = 'mobileRebranding'
export const DESKTOP_REBRANDING = 'desktopRebranding'

export const SHOP_LOGOS = {
  [TENANT_COM]: {
    [MOBILE]: { src: logoComMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoComDesktop, width: 180, height: 70 },
  },
  [TENANT_AT]: {
    [MOBILE]: { src: logoAtMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoAtDesktop, width: 180, height: 70 },
  },
  [TENANT_IT]: {
    [MOBILE]: {
      src: logoItMobile,
      width: 148,
      height: 45,
    },
    [DESKTOP]: { src: logoItDesktop, width: 197, height: 45 },
  },
  [TENANT_FR]: {
    [MOBILE]: { src: logoFrMobile, width: 188, height: 70 },
    [DESKTOP]: { src: logoFrDesktop, width: 188, height: 70 },
  },
  [TENANT_TEST]: {
    [MOBILE]: { src: logoTestMobile, width: 110, height: 43 },
    [DESKTOP]: { src: logoTestDesktop, width: 180, height: 70 },
  },
}
SHOP_LOGOS.default = SHOP_LOGOS[TENANT_COM]
